import { render } from "./CrawlConfigView.vue?vue&type=template&id=4c849bca&scoped=true"
import script from "./CrawlConfigView.vue?vue&type=script&lang=js"
export * from "./CrawlConfigView.vue?vue&type=script&lang=js"

import "./CrawlConfigView.vue?vue&type=style&index=0&id=4c849bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c849bca"]])

export default __exports__